module.exports = __webpack_public_path__ + "media/polyp.c5d5302a.wav";